import { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";
import "../component css/BackToTop.css";

const SHOW_AT = 500;

const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const pastThreshold = window.scrollY > SHOW_AT;
      const inHeroPin = document.body.classList.contains("hero-pinned");
      setVisible(pastThreshold && !inHeroPin);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    // Plain smooth scroll — the Hero's scrubbed ScrollTrigger tracks scroll
    // position, so this naturally reverses its timeline back to the pristine
    // start state. Killing the pin here (as Navbar's menu-close does) would
    // instead freeze the hero mid-animation since we stay on the same page.
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      className={`back-to-top${visible ? " is-visible" : ""}`}
      onClick={scrollToTop}
      aria-label="Back to top"
      title="Back to top"
    >
      <FaArrowUp />
    </button>
  );
};

export default BackToTop;
